import {
    Box,
    Drawer,
    Typography,
    TextField,
    IconButton,
    Divider,
    Button,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";
  import DeleteIcon from "@mui/icons-material/Delete";
  import { useEffect, useState } from "react";

  export default function CareGoalEditor({ open, onClose, goalData, onSave }) {
    const [name, setName] = useState(goalData.name);
    const [description, setDescription] = useState(goalData.description);
    const [treatments, setTreatments] = useState([]);
    const [followUps, setFollowUps] = useState([]);

    const [newTreatment, setNewTreatment] = useState({
        treatmentName: "",
        treatmentDescription: "",
      });

      const [newFollowUp, setNewFollowUp] = useState({
        followUpName: "",
        followUpDescription: "",
      });

    // Cargar datos cuando cambia goalData
    useEffect(() => {
      setName(goalData.name);
      setDescription(goalData.description);
      setTreatments(goalData.treatments || []);
      setFollowUps(goalData.followUps || []);
    }, [goalData]);

    const handleDeleteTreatment = (id) => {
      setTreatments((prev) => prev.filter((t) => t.patientTreatmentId !== id));
    };

    const handleDeleteFollowUp = (id) => {
      setFollowUps((prev) => prev.filter((f) => f.patientFollowUpId !== id));
    };

    const handleSave = () => {
      onSave({
        caregoalId: goalData.caregoalId,
        name,
        description,
        treatments,
        followUps,
      });
    };

    return (
      <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: 400, p: 2 } }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight="bold">
            Edit Care Goal
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <TextField
          fullWidth
          label="Goal Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
        />
        <TextField
          fullWidth
          multiline
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
        />

        {/* Treatments */}
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 3 }}>
          Treatments
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {treatments.length === 0 ? (
          <Typography variant="body2" fontStyle="italic">
            No treatments.
          </Typography>
        ) : (
          treatments.map((t) => (
            <Box
              key={t.patientTreatmentId}
              sx={{
                backgroundColor: "#f5f5f5",
                p: 1,
                borderRadius: 2,
                mb: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontWeight="bold">{t.treatmentName}</Typography>
                <Typography variant="body2">{t.treatmentDescription}</Typography>
              </Box>
              <IconButton color="error" size="small" onClick={() => handleDeleteTreatment(t.patientTreatmentId)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          ))
        )}

        <Box mt={2}>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
            Add New Treatment
        </Typography>
        <TextField
            label="Name"
            fullWidth
            size="small"
            sx={{ mb: 1 }}
            value={newTreatment.treatmentName}
            onChange={(e) => setNewTreatment({ ...newTreatment, treatmentName: e.target.value })}
        />
        <TextField
            label="Description"
            fullWidth
            size="small"
            multiline
            value={newTreatment.treatmentDescription}
            onChange={(e) => setNewTreatment({ ...newTreatment, treatmentDescription: e.target.value })}
            sx={{ mb: 1 }}
        />
        <Button
            variant="outlined"
            size="small"
            onClick={() => {
            if (newTreatment.treatmentName.trim()) {
                setTreatments((prev) => [
                ...prev,
                {
                    ...newTreatment,
                    patientTreatmentId: Date.now(),
                    treatmentType: "Custom",
                },
                ]);
                setNewTreatment({ treatmentName: "", treatmentDescription: "" });
            }
            }}
        >
            Add Treatment
        </Button>
        </Box>


        {/* FollowUps */}
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 3 }}>
          Follow Ups
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {followUps.length === 0 ? (
          <Typography variant="body2" fontStyle="italic">
            No follow ups.
          </Typography>
        ) : (
          followUps.map((f) => (
            <Box
              key={f.patientFollowUpId}
              sx={{
                backgroundColor: "#fff3e0",
                p: 1,
                borderRadius: 2,
                mb: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography fontWeight="bold">{f.followUpName}</Typography>
                <Typography variant="body2">{f.followUpDescription}</Typography>
              </Box>
              <IconButton color="error" size="small" onClick={() => handleDeleteFollowUp(f.patientFollowUpId)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          ))
        )}

        <Box mt={2}>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
            Add New Follow-Up
        </Typography>
        <TextField
            label="Name"
            fullWidth
            size="small"
            sx={{ mb: 1 }}
            value={newFollowUp.followUpName}
            onChange={(e) => setNewFollowUp({ ...newFollowUp, followUpName: e.target.value })}
        />
        <TextField
            label="Description"
            fullWidth
            size="small"
            multiline
            value={newFollowUp.followUpDescription}
            onChange={(e) => setNewFollowUp({ ...newFollowUp, followUpDescription: e.target.value })}
            sx={{ mb: 1 }}
        />
        <Button
            variant="outlined"
            size="small"
            onClick={() => {
            if (newFollowUp.followUpName.trim()) {
                setFollowUps((prev) => [
                ...prev,
                {
                    ...newFollowUp,
                    patientFollowUpId: Date.now(),
                },
                ]);
                setNewFollowUp({ followUpName: "", followUpDescription: "" });
            }
            }}
        >
            Add Follow-Up
        </Button>
        </Box>

        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button variant="contained" onClick={handleSave}>
            Save Changes
          </Button>
        </Box>
      </Drawer>
    );
  }
